import controller from './related-products.controller';
import templateBase from './templates/related-products-base.view.html';
import templateT1 from './templates/related-products-t1.view.html';
import templateT2 from './templates/related-products-t2.view.html';
import templateT3 from './templates/related-products-t3.view.html';
import templateT13 from './templates/related-products-t13.view.html';
import templateAD from './templates/related-products-adaptative.view.html';

let RelatedProductsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        productRelatedId: '<',
        categoryId: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if (__env.adaptative) {
        return templateAD;
    } else {
        if (response.RELATED_PRODUCTS.component == 'template_t1') {
            return templateT1;
        } else if (response.RELATED_PRODUCTS.component == 'template_t2') {
            return templateT2;
        }
        else if (response.RELATED_PRODUCTS.component == 'template_t3') { return templateT3; }
        else if (response.RELATED_PRODUCTS.component == 'template_t13') { return templateT13; }
        else {
            return templateBase;
        }
    }
}

export default RelatedProductsComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/related-products/related-products.component.js
 **/